export default {
  index: () => import('@v/Index'),

  whsite: () => import('@v/whsite/Index'),
  'whsite/sycn-record': () => import('@v/whsite/SycnRecord'),
  'whsite/sycn': () => import('@v/whsite/Sycn'),
  'whsite/product-sycn': () => import('@v/whsite/ProductSycn'),
  'whsite/tool/product-option-alter': () => import('@v/whsite/tool/ProductOptionAlter'),
  'whsite/tool/product-option-alter-all': () => import('@v/whsite/tool/ProductOptionAlterAll'),
  'whsite/tool/link-alter': () => import('@v/whsite/tool/LinkAlter'),
  'whsite/tool/site-move': () => import('@v/whsite/tool/SiteMove'),
  'whsite/tool/net-tools': () => import('@v/whsite/tool/NetTools'),
  'whsite/tool/sycn-rule-list': () => import('@v/whsite/tool/SycnRuleList'),
  'whsite/tool/sycn-code': () => import('@v/whsite/tool/SycnCode'),
  'whsite/create': () => import('@v/whsite/Form'),
  'whsite/:id(\\d+)/edit': () => import('@v/whsite/Form'),
  'whsite/site-url': () => import('@v/whsite/site-url/SiteUrl'),
  'whsite/site-url/create': () => import('@v/whsite/site-url/SiteUrlForm'),
  'whsite/site-url/:id(\\d+)/edit': () => import('@v/whsite/site-url/SiteUrlForm'),
  'whsite/top': () => import('@v/whsite/Top'),
  'whsite/site-url-count': () => import('@v/whsite/record/SiteUrlCount'),
  'whsite/site-build-record': () => import('@v/whsite/record/SiteBuild'),
  'whsite/sycn-code-record': () => import('@v/whsite/record/SycnCode'),
  'whsite/dns-list': () => import('@v/whsite/record/DnsList'),

  'whsite/siteb/index': () => import('@v/whsite/siteb/Index'),

  'whsite/order': () => import('@v/whsite/order/Index'),

  'whsite/user': () => import('@v/whsite/user/Index'),
  'whsite/tel': () => import('@v/whsite/tel/Index'),

  dhorder: () => import('@v/dhorder/Index'),
  'dhorder/product-order': () => import('@v/dhorder/ProductOrder'),
  'dhorder/show': () => import('@v/dhorder/Show'),
  'dhorder/paypal-statistics': () => import('@v/dhorder/PaypalStatistics'),
  'dhorder/cashout': () => import('@v/dhorder/cash-out/CashOut'),
  'dhorder/cashout/create': () => import('@v/dhorder/cash-out/CashOutForm'),
  'dhorder/cashout/:id(\\d+)/edit': () => import('@v/dhorder/cash-out/CashOutForm'),

  'report/export-file-list': () => import('@v/report/ExportRecordList'),
  'report/echart': () => import('@v/report/EChart'),
  'report/demo': () => import('@v/report/Demo'),

  'server-manage': () => import('@v/server/ServerManageList'),

  'admin-permissions': () => import('@v/admin-permissions/Index'),
  'admin-permissions/create': () => import('@v/admin-permissions/Form'),
  'admin-permissions/:id(\\d+)/edit': () => import('@v/admin-permissions/Form'),

  'admin-roles': () => import('@v/admin-roles/Index'),
  'admin-roles/create': () => import('@v/admin-roles/Form'),
  'admin-roles/:id(\\d+)/edit': () => import('@v/admin-roles/Form'),

  'admin-users': () => import('@v/admin-users/Index'),
  'admin-users/create': () => import('@v/admin-users/Form'),
  'admin-users/:id(\\d+)/edit': () => import('@v/admin-users/Form'),

  'config-categories': () => import('@v/config-categories/Index'),

  configs: () => import('@v/configs/Index'),
  'configs/create': () => import('@v/configs/Form'),
  'configs/:id(\\d+)/edit': () => import('@v/configs/Form'),

  'vue-routers': () => import('@v/vue-routers/Index'),
  'vue-routers/create': () => import('@v/vue-routers/Form'),
  'vue-routers/:id(\\d+)/edit': () => import('@v/vue-routers/Form'),

  'system-media': () => import('@v/system-media/Index'),
}
